<template>

    <v-panel title="Social">
        <v-section-links expanded />
        <v-section name="Size">
            <v-action-item-size type="size" :min="20" :max="100" />
            <v-action-item-size type="border-radius" :min="0" :max="100" />
        </v-section>
        <v-section name="Color">
            <v-action-item-color type="background-color" />
        </v-section>
        <v-section name="Position">
            <v-action-align :container="true" />
        </v-section>
        <v-section-block />
    </v-panel>

</template>

<script>

import ActionAlign from './actions/ActionAlign';
import ActionItemColor from './actions/ActionItemColor';
import ActionItemSize from './actions/ActionItemSize';
import Panel from './Panel';
import Section from './sections/Section';
import SectionBlock from './sections/SectionBlock';
import SectionLinks from './sections/SectionLinks';

export default {

    components: {
        'v-action-align': ActionAlign,
        'v-action-item-color': ActionItemColor,
        'v-action-item-size': ActionItemSize,
        'v-panel': Panel,
        'v-section': Section,
        'v-section-block': SectionBlock,
        'v-section-links': SectionLinks,
    },

}

</script>